import "./index.css";
import App from "./App.jsx";
import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./config/routes/buildroutes.jsx";


export const createRoot = ViteReactSSG({ routes });

// createRoot(document.getElementById('root')).render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
// ) 
